import { IframeView } from '@services/Marpple/client/widgets/CreatorDesign/IframeView.page.ts';
import { MuiF } from '../../../../../Mui/F/Function/module/MuiF.js';
import { OMPCoreUtilF } from '../../../../../OMP/Core/Util/F/Function/module/OMPCoreUtilF.js';
import { SimpleModalMuiF } from '../../../../../SimpleModal/F/Mui/module/SimpleModalMuiF.js';
import { $find, $setCss } from 'fxdom/es';
import { delay } from 'fxjs/es';

export const openFrame = (src) => {
  return new Promise((resolve) => {
    MuiF.openFrame(SimpleModalMuiF.frame, async (f, p, [t]) => {
      t.template = async () => {
        return new IframeView({ src }).toHtmlSSR();
      };
      t.appended = (el) => {
        $.don_loader_start();
        $setCss({ visibility: 'hidden' }, $find('.iframe-wrapper', el));
        OMPCoreUtilF.hydrationRune(IframeView);
      };
      t.showed = async (el) => {
        await delay(500, () => {});
        $setCss({ visibility: 'visible' }, $find('.iframe-wrapper', el));
        $.don_loader_end();
      };
    });
  });
};
